import { supabase } from '../supabase/supabase';

export const leadsService = {
  async submitLead(answers, contactInfo) {
    const payload = {
      name: contactInfo.NAME,
      company: contactInfo.COMPANY,
      email: contactInfo.EMAIL,
      website: contactInfo.WEBSITE,
      project_type: answers.projectType || '',
      problem: answers.problem || '',
      users_count: answers.users || '',
      timeline: answers.timeline || '',
      integrations: answers.integrations || ''
    };

    // Removed .select() here. We only want to insert, not read it back, 
    // which avoids the RLS read-access violation for anonymous users.
    const { data, error } = await supabase
      .from('stark_leads_1730000000')
      .insert([payload]);

    if (error) throw error;
    return data;
  },

  async getLeads(range = 'all') {
    let query = supabase
      .from('stark_leads_1730000000')
      .select('*')
      .order('created_at', { ascending: false });

    const now = new Date();
    
    if (range === 'today') {
      query = query.gte('created_at', new Date(now.setHours(0,0,0,0)).toISOString());
    } else if (range === 'week') {
      const weekAgo = new Date(now.setDate(now.getDate() - 7));
      query = query.gte('created_at', weekAgo.toISOString());
    } else if (range === 'month') {
      const monthAgo = new Date(now.setMonth(now.getMonth() - 1));
      query = query.gte('created_at', monthAgo.toISOString());
    }

    const { data, error } = await query;
    if (error) throw error;
    
    return data;
  }
};